export default __webpack_public_path__ + "static/media/630.de23cab7.png";